export default "__VITE_ASSET__BOgRWO4u__"